// 手机号
export const phoneNumRegx =  /^1[3456789]\d{9}$/;
// 手机号|电话号
export const phoneTel =  /^((0\d{2,3}-\d{7,8})|(1[23456789]\d{9}))$/;

export const tel = /^0\d{2,4}-?\d{7,8}$/;
// 邮箱
export const emailRegx =  /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
// 数字或字母
export const numNCharRegx =  /^[A-Za-z0-9]+$/;
// 中文
export const chineseRegx =  /^[\u4e00-\u9fa5]+$/;
// 非符号-数字/字母/中文
export const nonSymbolRegx =  /^[0-9a-zA-Z\u4e00-\u9fa5]+$/;
// 车牌号
export const plateNoRegx =  /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
// 修改密码格式(8到20位字符必须包含字母和数字和特殊符号)
export const resetPass = /^(?=.*\d)(?=.*[a-z])(?=.*[!-\/:-@\[-`{-~])[!-~]{8,20}$/i



